"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const dateAndTime_1 = __importDefault(require("./dateAndTime"));
const navigationMenu_1 = __importDefault(require("./navigationMenu"));
const header_1 = __importDefault(require("./header"));
const footer_1 = __importDefault(require("./footer"));
const searchFilters_1 = __importDefault(require("./searchFilters"));
const editCommentPopper_1 = __importDefault(require("./editCommentPopper"));
const notifications_1 = __importDefault(require("./notifications"));
const textEditor_1 = __importDefault(require("./textEditor"));
const appSearch_1 = __importDefault(require("./appSearch"));
const policyAccept_1 = __importDefault(require("./policyAccept"));
const hoaSelect_1 = __importDefault(require("./hoaSelect"));
const userSelection_1 = __importDefault(require("./userSelection"));
const notificationModals_1 = __importDefault(require("./notificationModals"));
const changesHistory_1 = __importDefault(require("./changesHistory"));
const pepSiginingModal_1 = __importDefault(require("./pepSiginingModal"));
const telegramModal_1 = __importDefault(require("./telegramModal"));
const commentFeed_1 = __importDefault(require("./commentFeed"));
const usefulAddress_1 = __importDefault(require("./usefulAddress"));
const messages_1 = __importDefault(require("./messages"));
const fastMenu_1 = __importDefault(require("./fastMenu"));
const table_1 = __importDefault(require("./table"));
const appeals_1 = __importDefault(require("./appeals"));
const files_1 = __importDefault(require("./files"));
exports.default = {
  dateAndTime: dateAndTime_1.default,
  navigationMenu: navigationMenu_1.default,
  header: header_1.default,
  footer: footer_1.default,
  searchFilters: searchFilters_1.default,
  editCommentPopper: editCommentPopper_1.default,
  notifications: notifications_1.default,
  textEditor: textEditor_1.default,
  appSearch: appSearch_1.default,
  policyAccept: policyAccept_1.default,
  hoaSelect: hoaSelect_1.default,
  userSelection: userSelection_1.default,
  notificationModals: notificationModals_1.default,
  changesHistory: changesHistory_1.default,
  pepSiginingModal: pepSiginingModal_1.default,
  telegramModal: telegramModal_1.default,
  commentFeed: commentFeed_1.default,
  usefulAddress: usefulAddress_1.default,
  messages: messages_1.default,
  fastMenu: fastMenu_1.default,
  table: table_1.default,
  appeals: appeals_1.default,
  files: files_1.default
};